/**
 * «Форма комнаты» of a new project, as the app's first-design onboarding asks it (`RoomPlanShapes`, «Ты сможешь
 * поменять или уточнить форму позже»): its six ready rooms or an empty plan to draw on. A radio group: the arrows move
 * the choice and the focus together, Home and End go to the ends, a click or a tap chooses.
 */
import { useId, useRef, type KeyboardEvent } from 'react';
import { ROOM_SHAPES, type RoomShapeId } from '../../state/roomShapes';
import { Icon } from '../Icon';
import { RoomShapePicture } from '../RoomShapePicture';
import { t } from '../../i18n/I18n';

const CHOICES: { id: RoomShapeId | null; readonly title: string }[] = [{ id: null, get title() { return t('#HomeShapeFromScratch'); } }, ...ROOM_SHAPES];

export function RoomShapeChoice({ value, onChange, disabled }: { value: RoomShapeId | null; onChange: (value: RoomShapeId | null) => void; disabled?: boolean }) {
  const group = useRef<HTMLDivElement>(null), titleId = useId();
  const keyDown = (event: KeyboardEvent) => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
    const at = CHOICES.findIndex(choice => choice.id === value);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? CHOICES.length - 1 : step === undefined ? -1 : (at + step + CHOICES.length) % CHOICES.length;
    if (next < 0) return;
    event.preventDefault();
    onChange(CHOICES[next].id);
    group.current?.querySelectorAll<HTMLButtonElement>('[role=radio]')[next]?.focus();
  };
  return <div className="ws-shapes">
    <span className="ws-shapes-title" id={titleId}>{t('#RoomShapeTitle')}</span>
    <div ref={group} className="ws-shape-grid" role="radiogroup" aria-labelledby={titleId} onKeyDown={keyDown}>
      {CHOICES.map(choice => <button key={choice.id ?? 'empty'} type="button" role="radio" className="ws-shape" aria-checked={choice.id === value}
        tabIndex={choice.id === value ? 0 : -1} disabled={disabled} title={choice.id ? undefined : t('#HomeShapeFromScratchHint')} onClick={() => onChange(choice.id)}>
        <span className="ws-shape-picture">{choice.id ? <RoomShapePicture id={choice.id} size={44} /> : <Icon name="pencil" size={22} />}</span>
        <span className="ws-shape-title">{choice.title}</span>
      </button>)}
    </div>
  </div>;
}
